import { EdnaWrapper, getCurrentTheme } from '@providers/EdnaProvider';
import styled, { keyframes } from 'styled-components';
import { FC } from 'react';
import {
  LoadingPlaceholderGradientProps,
  StyledLoadingPlaceholderGradientTypes,
} from './types';

const PlaceholderShimmer = keyframes`
  from {
    background-position: 200% 0;
  }

  to {
    background-position: -200% 0;
  }
`;

const StyledLoadingPlaceholderGradient = styled.div<
  LoadingPlaceholderGradientProps & StyledLoadingPlaceholderGradientTypes
>`
  animation: ${PlaceholderShimmer} 4s linear infinite;
  animation-fill-mode: forwards;
  background: ${({ startColor }) => startColor};
  background: ${({ startColor, endColor }) =>
    `
    linear-gradient(
      to right,
      ${startColor} 10%,
      ${endColor} 20%,
      ${endColor} 22%,
      ${startColor} 33%
    )`};
  background-size: 300% 100%;
  border-radius: 2px;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin: ${(props) => props.margin};
`;

/**
 *  Component used as a Shimmer during loading state in components. The `width` and `height` must be set for it to work properly.
 */

const LoadingPlaceholderGradient: FC<LoadingPlaceholderGradientProps> = ({
  width = 'auto',
  height = 'auto',
  margin,
  className,
}) => {
  const { colors } = getCurrentTheme();

  const startColor = colors.grey100;
  const endColor = colors.grey075;

  return (
    <EdnaWrapper>
      <StyledLoadingPlaceholderGradient
        role="status"
        aria-busy="true"
        aria-label="Loading"
        aria-live="polite"
        width={width}
        height={height}
        margin={margin}
        className={className}
        startColor={startColor}
        endColor={endColor}
      />
    </EdnaWrapper>
  );
};

export default LoadingPlaceholderGradient;
